import React from "react";
import PersonGenericSkeleton from "./PersonGenericSkeleton";

function PersonDetailSkeleton() {
  return (
    <>
      <PersonGenericSkeleton />
    </>
  );
}

export default PersonDetailSkeleton;
